import { RadioProps } from "@bluframe/blublocks"
import {
  NewsSource,
  Review
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { memo } from "react"

import List from "./List"

export interface Props {
  display: NewsSource[] | Review[]
  flagLoading: boolean
  isShowFlagButton: boolean
  label: string
  name: string
  onSelect: RadioProps["onChange"]
  onToggleFlagged: (id: string, isFlagged: boolean) => () => void
  selected: RadioProps["value"]
}

export interface ComponentProps extends Props {}

export default memo(List)
